import type { WidgetSpec } from '@hero/schema';
import { getObjectId } from '@hero/schema';
import { normalizeEntityId } from './normalize-entity-id';

/** Coerce and normalize entity IDs inside widget specs from SSE / API JSON. */
export const normalizeWidgetSpec = (raw: unknown): WidgetSpec | null => {
  if (typeof raw !== 'object' || raw === null || !('type' in raw)) {
    return null;
  }

  const spec = raw as WidgetSpec;

  switch (spec.type) {
    case 'client_card':
      return {
        ...spec,
        clientId: getObjectId(normalizeEntityId(spec.clientId)),
      };
    case 'order_card':
      return {
        ...spec,
        orderId: getObjectId(normalizeEntityId(spec.orderId)),
      };
    case 'driver_card':
      return {
        ...spec,
        driverId: getObjectId(normalizeEntityId(spec.driverId)),
      };
    case 'vehicle_card':
      return {
        ...spec,
        vehicleId: getObjectId(normalizeEntityId(spec.vehicleId)),
      };
    case 'saved_location_card':
      return {
        ...spec,
        savedLocationId: getObjectId(normalizeEntityId(spec.savedLocationId)),
      };
    case 'order_list':
      return {
        ...spec,
        orderIds: spec.orderIds.map(id => getObjectId(normalizeEntityId(id))),
      };
    default:
      return spec;
  }
};
